const ONE_TIME = {
  OPTION_ONE: "ایمیل",
  FORM_SUBMIT: "ارسال",
  INVALID_PHONE_TOOLTIP: "شماره تلفن وارد شده صحیح نمی‌باشد!",
  INVALID_EMAIL_TOOLTIP: "ایمیل وارد شده صحیح نمی‌باشد!",
  DISABLE_TOOLTIP: "پر کردن فیلد انتخاب شده ضروری می‌باشد!",
  RETURN_BUTTON: "بازگشت",
  IMPORT_CODE_PLACEHOLDER: "کد را وارد کنید...",
  ENTER_TO_RAYCHAT: "ورود به رایچت",
  IMPORT_CODE_TOOLTIP: "کد وارد شده باید 4 رقم باشد!",
  PAGE_TITLE: "ورود با کد یکبار مصرف!",
  FORM_DESC: `ابتدا یکی از گزینه های زیر را انتخاب کنید، سپس آدرس ایمیل یا شماره تلفنی که در هنگام عضویت استفاده کرده‌اید را وارد کنید، کد یکبار مصرف برای شما ارسال می‌شود.
    `,
  IMPORT_CODE_DESC: "کد ارسال شده به ایمیل یا شماره تلفن خود را وارد کنید.",
  WITH_COUNTRY_MOBILE_PLACEHOLDER: "موبایل",
};

export default ONE_TIME;
